import {
    AcquisitionPropertyModel,
    OriginalRevenueMarketRentModeType,
    PropertyManagementSystem,
    PropertyType,
    RevenueModelType
} from "../../__generated__/generated_types";
import {AuthUser} from "../auth_types";


export interface MinimalProperty {
    id: string;
    clientId: string;
    name: string;
    systemName: string;
    unitLevelModelingEnabled: boolean;
    address?: string | null;
    externalId?: string | null;
    code?: string | null;
    fiscalYearStartMonthIndex: number;
    reforecastStartMonthIndex: number;
    reforecastYear: number;
    budgetYear: number;
    propertyType: PropertyType;
    isAcquisitionProperty: boolean;
    acquisitionBudgetStartMonth?: number;
    acquisitionBudgetYear?: number;
    createdAt: string;
}

export interface Property extends MinimalProperty {
    revenueModel: RevenueModelType;
    originalRevenueMarketRentModeType: OriginalRevenueMarketRentModeType;
    originalRevenueModelSubsidyEnabled: boolean;
    propertyManagementSystem?: PropertyManagementSystem | null;
}

export function mapProperty(property: AuthUser["properties"][0]): Property {
    return {
        ...property,
        budgetYear: property.reforecastYear + 1,
        name: property.displayName ? property.displayName : property.name,
        systemName: property.name,
        isAcquisitionProperty: property.propertyType == PropertyType.Acquisition,
    };
}

export function asMinimalProperty(property: Omit<MinimalProperty, "budgetYear" | "systemName" | "isAcquisitionProperty">): MinimalProperty {
    return {
        ...property,
        budgetYear: property.reforecastYear + 1,
        systemName: property.name,
        isAcquisitionProperty: property.propertyType == PropertyType.Acquisition,
    };
}

export function propertyCreatedAt(property: MinimalProperty): {year: number, month: number, day: number} {
    const createdAt = property.createdAt as any;
    if(createdAt instanceof Date) {
        return {
            year: createdAt.getUTCFullYear(),
            month: createdAt.getUTCMonth() + 1,
            day: createdAt.getUTCDate()
        };
    }
    if(typeof createdAt === "string") {
        const date = new Date(createdAt);
        return {
            year: date.getUTCFullYear(),
            month: date.getUTCMonth() + 1,
            day: date.getUTCDate()
        };
    }
    return {year: 0, month: 0, day: 0};
}

export function propertyDisplayBudgetYear(property: Property): number {
    if(property.isAcquisitionProperty && property.acquisitionBudgetYear) {
        return property.acquisitionBudgetYear;
    }
    return property.budgetYear;
}

export function asBudgetProperty(property: Omit<AcquisitionPropertyModel, "similarAcquisitionProperties" | "state">): Property {
    return {
        id: property.id,
        clientId: property.clientId,
        name: property.name,
        reforecastYear: property.reforecastYear,
        reforecastStartMonthIndex: property.reforecastStartMonthIndex,
        budgetYear: property.reforecastYear + 1,
        fiscalYearStartMonthIndex: 0,
        revenueModel: property.revenueConfiguration,
        originalRevenueMarketRentModeType: property.originalRevenueMarketRentModeType,
        originalRevenueModelSubsidyEnabled: property.originalRevenueModelSubsidyEnabled,
        systemName: "",
        unitLevelModelingEnabled: false,
        propertyManagementSystem: null,
        propertyType: PropertyType.Acquisition,
        isAcquisitionProperty: true,
        acquisitionBudgetStartMonth: property.acquisitionBudgetStartMonth,
        acquisitionBudgetYear: property.acquisitionBudgetYear,
        createdAt: property.createdAt
    };
}